<template>
  <div class="search-acu">
    <v-autocomplete
			solo
			v-model="point"
			:items="pointOptions"
			:loading="loadingPoints"
			:search-input.sync="search"
			hide-selected
			hide-details
			item-text="name"
			item-value="id"
			:placeholder="$gettext('Search...')"
			clearable
			return-object
			outlined
			no-filter
			:no-data-text="$gettext('No results')"
			@input="addPoint"
			prepend-inner-icon="search"
		>
			<template slot="item" slot-scope="{ parent, item }">
				<v-col cols="12" md="12" class="pa-0">
					<v-list-item class="pa-0" :key="item.id" style @click.capture="clickPoint($event, item)">
						<v-list-item-icon class="mr-3">
							<v-icon color="primary">$vuetify.icons.acuIcon</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								{{item.name}}
							</v-list-item-title>
							<v-list-item-subtitle>
								{{getSide(item.side)}}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</template>
		</v-autocomplete>
  </div>
</template>

<script>
import axios from "axios";

export default {
	name: "SearchPoints",
	props: {
		auricular: {
			default: false
		},
		ashi: {
			default: false
		}
	},
  data: () => ({
    point: null,
    pointOptions: [],
    loadingPoints: false,
    search: null
  }),
  methods: {
    makeRequest(value) {
			clearTimeout(this._timerId);
			if (value) {
				this._timerId = setTimeout(() => {
					console.log("API CALL");
					this.loadingPoints = true;
					axios
						.get("/acupuncture/search", {
							params: {
								value: value.toLowerCase(),
								auricular: this.auricular,
								group: 'all',
								ashi: this.ashi
							}
						})
						.then(response => {
              console.log(response.data);
              this.pointOptions = response.data.points.sort((a,b) => {return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});});
              this.loadingPoints = false;
						})
            .catch(error => {
              console.log(error);
              this.loadingPoints = false;
            });
				}, 300);
			} else {
				this.pointOptions = [];
			}
    },
    clickPoint(event, point) {
      console.log(event, point);
      this.addPoint();
    },
    addPoint() {
			if (this.point) {
				this.$emit("add-point", JSON.parse(JSON.stringify(this.point)));
				this.point = null;
				this.search = null;
				this.pointOptions = [];
			}
		},
		getSide(side) {
			if (side === "left") return this.$gettext("Left");
			else if (side === "right") return this.$gettext("Right");
			else return this.$gettext("Center");
		}
  },
  watch: {
		search(value) {
			console.log("CHANGE SEARCH");
			this.makeRequest(value);
		}
	}
}
</script>